import React, { useState } from 'react';
import {
  TopToolbar,
  FilterButton,
  Button,
  useListContext,
  useStore,
  useNotify,
} from 'react-admin';
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import CreateLeadModal from './CreateLeadModal.component';
import CustomExportButton from './CustomExportButton.component';
import logger from '../../utils/logger';
const ListActions = () => {
  const { total, filterValues, setFilters, refetch } = useListContext();
  const notify = useNotify();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  // Handle clearing all filters except the default active status
  const handleClearFilters = () => {
    // Reset to only keep default status filter
    setFilters({ status: 'active' });
    notify('Filters cleared', { type: 'info' });
  };

  // Check if we have any filters other than the default status
  // Debugging to see actual filter values
  logger.log('Current filter values:', filterValues);

  const hasActiveFilters = Object.keys(filterValues).length > 0 &&
    (Object.keys(filterValues).length > 1 ||
      (Object.keys(filterValues).length === 1 &&
        (!('status' in filterValues) || filterValues.status !== 'active')));

  const handleCreateSuccess = () => {
    // Refresh the list to show the new lead
    refetch();
    // Note: Success notification is already shown by the hook
  };

  return (
    <TopToolbar sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      padding: '8px 0'
    }}>
      <Button
        label="Add Lead"
        onClick={() => setIsCreateModalOpen(true)}
        startIcon={<AddIcon />}
        variant="contained"
        color="primary"
        sx={{ mr: 1 }}
      />
      <FilterButton className="filter-button" />
      {hasActiveFilters && (
        <Button
          label="Clear Filters"
          onClick={handleClearFilters}
          startIcon={<ClearIcon />}
          variant="outlined"
          color="primary"
          sx={{ ml: 1 }}
        />
      )}
      <CustomExportButton />

      <CreateLeadModal
        open={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onSuccess={handleCreateSuccess}
      />
    </TopToolbar>
  );
};

export default ListActions;
